/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-27 16:02:16
 * @LastEditors: K
 * @LastEditTime: 2022-10-09 09:27:30
 */
import { unwrapResult } from "@reduxjs/toolkit"
import {
  Col,
  DatePicker,
  Dropdown,
  Form,
  Input,
  Menu,
  Modal,
  Popover,
  Radio,
  Row,
  Select,
  Space,
  Tag,
} from "antd"
import moment from "moment"
import React, { ReactElement, useContext, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { ThemeContext } from "../../../theme/ThemeContext"
import { DateTimeFormat } from "../../../models/datetime"
import styles from "../maintenance.module.css"
import { GenderOptions, getGenderName } from "../../../models/user"
import { getAppointName, getEducationName, getOperateName, getPracticeCategoryName, getPracticeLevelName, getSexName } from "./doctor"

interface ReportModalProps {
  visible: boolean
  detail?: any
  onCancel: () => void
  onOk: (data: any) => void
}

export const DoctorDetailModal = ({
  visible,
  detail,
  onCancel,
  onOk,
}: ReportModalProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const [idCardRules, setIdCardRules] = useState<any[]>([
    {
      pattern: /(^\d{15}$)|(^\d{16}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
      message: "身份证格式错误",
    },
    {
      max: 18,
      message: "最长18位!",
    },
    {
      required: true,
    },
  ])

  return (
    <Modal
      visible={visible}
      title="医生详情"
      width={800}
      onCancel={onCancel}
      footer={null}
    >
      <Col style={{ paddingBottom: 20 }}>
        <Row className={styles.formRow}>
          <Col span={24}>
            <Row>
              <Col span={4} className={styles.leftCol}>
                医生姓名：
              </Col>
              <Col
                span={20}
                className={styles.rightCol}
                style={{ borderRight: "none" }}
              >
                {detail?.name}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className={styles.formRow}>
          <Col span={12}>
            <Row>
              <Col span={8} className={styles.leftCol}>
                性别：
              </Col>
              <Col span={16} className={styles.rightCol}>
                {getSexName(detail?.sex)}
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={8} className={styles.leftCol}>
                医生类型：
              </Col>
              <Col
                span={16}
                className={styles.rightCol}
                style={{ borderRight: "none" }}
              >
                {getOperateName(detail?.physicianType)}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className={styles.formRow}>
          <Col span={12}>
            <Row>
              <Col span={8} className={styles.leftCol}>
                民族：
              </Col>
              <Col span={16} className={styles.rightCol}>
                {detail?.nation}
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={8} className={styles.leftCol}>
                出身年月：
              </Col>
              <Col
                span={16}
                className={styles.rightCol}
                style={{ borderRight: "none" }}
              >
                {detail?.birthday}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className={styles.formRow}>
          <Col span={12}>
            <Row>
              <Col span={8} className={styles.leftCol}>
                学历：
              </Col>
              <Col span={16} className={styles.rightCol}>
                {getEducationName(detail?.education)}
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={8} className={styles.leftCol}>
                毕业学校：
              </Col>
              <Col
                span={16}
                className={styles.rightCol}
                style={{ borderRight: "none" }}
              >
                {detail?.graduationSchool}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className={styles.formRow}>
          <Col span={12}>
            <Row>
              <Col span={8} className={styles.leftCol}>
                资格证书编号：
              </Col>
              <Col span={16} className={styles.rightCol}>
                {detail?.qualification}
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={8} className={styles.leftCol}>
                执业证书编号：
              </Col>
              <Col
                span={16}
                className={styles.rightCol}
                style={{ borderRight: "none" }}
              >
                {detail?.practice}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className={styles.formRow}>
          <Col span={12}>
            <Row>
              <Col span={8} className={styles.leftCol}>
                执业级别：
              </Col>
              <Col span={16} className={styles.rightCol}>
                {getPracticeLevelName(detail?.practiceLevel)}
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={8} className={styles.leftCol}>
                执业类别：
              </Col>
              <Col
                span={16}
                className={styles.rightCol}
                style={{ borderRight: "none" }}
              >
                {getPracticeCategoryName(detail?.practiceCategory)}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className={styles.formRow}>
          <Col span={12}>
            <Row>
              <Col span={8} className={styles.leftCol}>
                执业范围：
              </Col>
              <Col span={16} className={styles.rightCol}>
                {detail?.practiceArea}
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={8} className={styles.leftCol}>
                任职资格：
              </Col>
              <Col
                span={16}
                className={styles.rightCol}
                style={{ borderRight: "none" }}
              >
                {getAppointName(detail?.appoint)}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row className={styles.formRow}>
          <Col span={12}>
            <Row>
              <Col span={8} className={styles.leftCol}>
                发证机关：
              </Col>
              <Col span={16} className={styles.rightCol}>
                {detail?.licenceOrgan}
              </Col>
            </Row>
          </Col>
          <Col span={12}>
            <Row>
              <Col span={8} className={styles.leftCol}>
                发证日期：
              </Col>
              <Col
                span={16}
                style={{ borderRight: "none" }}
                className={styles.rightCol}
              >
                {detail?.licenceDate}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row
          className={styles.formRow}
          style={{ borderBottom: "1px solid #eef4ff" }}
        >
          <Col span={24}>
            <Row>
              <Col span={4} className={styles.leftCol}>
                资格发证日期：
              </Col>
              <Col
                span={16}
                className={styles.rightCol}
                style={{ borderRight: "none" }}
              >
                {detail?.qualificationDate}
              </Col>
            </Row>
          </Col>
        </Row>
      </Col>
    </Modal>
  )
}
